import { formatPhone } from "./formatPhone.js";
import { toggleFieldAttribute } from "./toggleFieldAttribute.js";

export function toggleForeignPhone(country) {
    const intlPhoneInputs = document.querySelectorAll("intl-phone-input");

    if (intlPhoneInputs.length > 0) {
        intlPhoneInputs.forEach((input) => input.setCountry(country));
    }

    const toggle = country !== "USA";

    if (toggle) {
        $('[type="tel"]').off("keyup", formatPhone);
    } else {
        $('[type="tel"]').on("keyup", formatPhone);
    }
    $('[type="tel"]').each(function (index, input) {
        toggleFieldAttribute(input, "phone", !toggle);
    });
}
